export const CHECKOUT_DATA = 'checkoutData';
export const ADDRESS = 'address';
export const SUBSCRIPTION_SUMMARY = 'subscriptionSummary';
